// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-content {
  --background: #fff !important;
}
:host ion-list {
  background: var(--cms-app-background-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/chat-pages/full-screen-chat-list/full-screen-chat-list.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;AAAJ;AAGE;EACE,sDAAA;AADJ","sourcesContent":[":host {\n  ion-content {\n    --background: #fff !important;\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
